import { doc, updateDoc, getFirestore } from 'firebase/firestore';

const updateCustomer = (customerId: string, values: any) => {
  updateDoc(doc(getFirestore(), 'customers', customerId), values);
};

export default updateCustomer;
